import { createAction, props } from '@ngrx/store';
import { Merkmal } from '@models/merkmalbaum';

export const setSelectedMerkmal = createAction(
  '[Merkmal] Select Merkmal',
  props<{ lastSelectedMerkmal: string }>()
);

export const loadMerkmale = createAction(
  '[Merkmal] Load Merkmale'
);

export const loadMerkmaleSuccess = createAction(
  '[Merkmal] Load Merkmale Success',
  props<{ merkmale: Merkmal[] }>()
);

export const loadMerkmaleError = createAction(
  '[Merkmal - Effect] Load Merkmale Error'
);
